import React, { useEffect, useState } from 'react';
import Cookie from 'js-cookie';
import { Loading, Dialog, Button } from '@ok/okd';

const { utils: { ont } = {} } = window;

const Top = () => {
  const [isLoading, setIsLoading] = useState(true);

  const isApp = () => {
    const sUserAgent = navigator.userAgent.toLowerCase();
    return sUserAgent.match(/okapp/i) == 'okapp';
  };

  const openEmailModal = () => {
    const dialog = Dialog.show({
      width: 450,
      children: (
        <div
          style={{
            fontSize: 18,
            textAlign: 'center',
            marginTop: 30,
          }}
        >
          <p>下記のメールアドレスにご連絡ください</p>
          <p>
            <a href="mailto:support@okj.com">support@okj.com</a>
          </p>
        </div>
      ),
      onClose: () => {
        dialog.destroy();
        if (isApp()) {
          window.jsbridge.navigation.close(true);
        } else {
          window.history.back();
        }
      },
    });
  };

  const openNoLoginModal = () => {
    const dialog = Dialog.show({
      width: 450,
      children: (
        <div>
          <div style={{ fontWeight: 900, fontSize: 18, marginTop: 30 }}>
            サポートをより快適にご利用いただくには、ログインしてください
          </div>
          <div style={{ marginTop: 30 }}>
            <Button
              type="primary"
              style={{ width: '100%' }}
              onClick={() => {
                if (isApp()) {
                  window.jsbridge
                    .login()
                    .then(() => {
                      window.jsbridge.navigation.close(true);
                    })
                    .catch(() => {
                      window.jsbridge.navigation.close(true);
                    });
                } else {
                  window.location.href =
                    '/account/login?forward=/pages/inquiry';
                }
              }}
            >
              ログイン
            </Button>
          </div>
          <div style={{ marginTop: 15 }}>
            <Button
              style={{ width: '100%' }}
              onClick={() => {
                dialog.destroy();
                openEmailModal();
              }}
            >
              ゲストとして進める
            </Button>
          </div>
        </div>
      ),
      onClose: () => {
        if (isApp()) {
          window.jsbridge.navigation.close(true);
        } else {
          window.history.back();
        }
      },
    });
  };

  const getLang = () => {
    let lang = Cookie.get('locale');
    if (lang.includes('ja')) {
      lang = 'ja-jp';
    } else if (lang.includes('zh')) {
      lang = 'zh-cn';
    } else if (lang.includes('en')) {
      lang = 'en-us';
    } else {
      lang = 'ja-jp';
    }
    return lang;
  };

  const getZendeskToken = () => {
    const lang = getLang();

    ont
      .get('/v3/users/zendesk/sso')
      .then((res) => {
        setIsLoading(false);
        if (typeof res?.data?.data !== 'string') {
          throw res;
        }
        const { data } = res.data;

        if (
          window.location.host.includes('okcoin.jp') ||
          window.location.host.includes('okj.com')
        ) {
          window.location.href = `https://okj-help.zendesk.com/access/jwt?jwt=${data}&return_to=https://okj-help.zendesk.com/hc/${lang}/requests/new`;
        } else {
          // DB汚染を防ぐためTokenが使えない
          openNoLoginModal();
        }
      })
      .catch(() => {
        setIsLoading(false);
        openNoLoginModal();
      });
  };

  useEffect(() => {
    (async () => 
      {
        if (isApp()) {
          const appToken = await window.jsbridge.getToken().catch(()=>null);
          if(appToken) localStorage.setItem('token', appToken);
        }
        getZendeskToken();
      }
    )()
  }, []);

  return (
    <div className="container">
      <Loading loading={!!isLoading} hasMask />
    </div>
  );
};

export default Top;
